import { render, staticRenderFns } from "./alert-certificate.vue?vue&type=template&id=38fe0a6d"
import script from "./alert-certificate.vue?vue&type=script&lang=js"
export * from "./alert-certificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports